import React from 'react';
import _ from 'lodash';
import { DotIndicator } from '@bbkAdminComponents/indicators/dot';

import './styles/tooltips.scss';

type Props = {
  text: string;
  indicator?: React.ComponentProps<typeof DotIndicator>['dotColor'];
};
const TipBoldLabel: React.FC<Props> = (props) => {
  const { text, indicator } = props;
  return (
    <div className="tip-bold-label">
      {!_.isNil(indicator) && (
        <DotIndicator dotColor={indicator} className="small" />
      )}
      {text}
    </div>
  );
};

export default TipBoldLabel;
